import { Timespan } from '@hap/utils'

import { useAnalyticsPresets } from '../../-components/hooks'
import { MetricFilters } from '../../-components/metric-widget'
import { EvaluationScores } from './evaluation-scores'

import type { JSX } from "react";

export function ScorecardCriteriaTrends(props: Props): JSX.Element {
  const queryContext = useAnalyticsPresets(props)
  return <EvaluationScores {...queryContext} />
}

// function useScorecardCriteriaIndicators(queryContext: AnalyticsQueryFilterContext) {
//   const { data: agentBelowGoalResponse, loading } = useAnalytics({
//     filters: queryContext.filters,
//     aggregations: {
//       count: {
//         field: 'handledBy',
//         dataset: 'interactions',
//       },

//       score: {
//         op: 'avg',
//         field: 'score',
//         dataset: 'evaluationCriteriaScores',
//         having: {
//           op: 'lt',
//           value: 0.85,
//         },
//       },
//     },

//     timespan: queryContext.timespan,
//     dataset: 'evaluationCriteriaScores',
//   })

//   const { data: avgScoreResponse } = useAnalytics({
//     filters: queryContext.filters,
//     aggregations: {
//       avgScore: {
//         op: 'avg',
//         field: 'score',
//         dataset: 'evaluationCriteriaScores',
//       },
//     },

//     timespan: queryContext.timespan,
//     dataset: 'evaluationCriteriaScores',
//   })

//   const { data: totalAgentsResponse } = useAnalytics({
//     filters: queryContext.filters,
//     aggregations: {
//       count: {
//         op: 'countDistinct',
//         field: 'handledBy',
//       },
//     },

//     timespan: queryContext.timespan,
//     dataset: 'interactions',
//   })

//   const agentsBelowGoal = agentBelowGoalResponse ? agentBelowGoalResponse.length : 0
//   const totalAgents = totalAgentsResponse ? parseInt(totalAgentsResponse[0]?.count) : null

//   return {
//     avgScore: avgScoreResponse?.[0]?.avgScore ?? null,
//     totalAgents,
//     agentsBelowGoal: agentsBelowGoal,
//     percentAgentsBelowGoal: totalAgents ? agentsBelowGoal / totalAgents : 0,
//     loading,
//   }
// }

interface Props {
  scorecardId?: string
  criteriaId: string
  filters: MetricFilters
  timespan: Timespan.StaticTimespan
}
